import React, { useRef } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../../components/psc/lib/SearchBox'
import StatusOptionsMulti from '../../components/psc/lib/StatusOptionsMulti'
import GncDataTable from '../../components/psc/lib/GncDataTable'
import useTableSlots from '../../hooks/useTableSlots'

const TemplatePlaceholders = () => {
    const table = useRef(null)
    const urlGetData = '/v0/template_placeholders'
    const localStorageOrderKey = 'tblTemplatePlaceholdersOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const columns = [
        { data: 'label' },
        { data: 'placeholder' },
        { data: 'source' },
        { data: 'objects' },
    ]

    const tableHead = (
        <tr>
            <th>Field</th>
            <th>Placeholder</th>
            <th>Source</th>
            <th>Configured Item</th>
        </tr>
    )

    const tableSlots = {
        3: (data, type, obj) => {
            return data.map(o => o['name']).join(', ');
        },
    }

    return (
        <div className="wrapper wrapper-content">
            
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>SMART Template Placeholders</h2>

                            <div className="pre-table-buttons" style={{paddingTop: '6px', paddingBottom: '6px', marginBottom: '5px'}}>
                                <Link to="/cadm/templates">Manage Templates</Link>
                            </div>
                            
                            <div key="subText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                Activate <strong>SMART templates</strong> by adding <strong>placeholders</strong> to all of your <strong>Microsoft Word</strong> template documents.

                                <span className="stonly template-placeholders-intro-1"></span>
                            </div>
                            <div key="subText2" style={{color: 'rgba(103, 106, 108, 0.65)'}} className="template-placeholders-intro-2">
                                Use the item filter below to view the fields and placeholders available for each <strong>configured item</strong>.
                            </div>

                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                                <StatusOptionsMulti
                                    tableRef={table}
                                    statusColumnIndex="3"
                                    statusColumnIsMulti={true}
                                    fetchUrl="/v0/template_objects"
                                    localStorageKey="placeholder-template-objects"
                                    placeholder="Select Configured Item..."
                                />
                            </div>

                            <GncDataTable
                                tableRef={table}
                                dataUrl={urlGetData}
                                defaultOrder={defaultOrder}
                                localStorageOrderKey={localStorageOrderKey}
                                columns={columns}
                                tableSlots={tableSlots}
                                tableHead={tableHead}
                                tableFoot={tableHead}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default TemplatePlaceholders
